import React from 'react';
import useGameStore from '../../store/gameStore';
import './Header.css';

export default function Header() {
  const { balance, currency, mode, connected, soundEnabled, animationsEnabled,
          setSoundEnabled, setAnimationsEnabled } = useGameStore();

  return (
    <header className="header">
      <div className="header-left">
        <div className="logo">
          <span className="logo-icon">🐰</span>
          <span className="logo-text">Rabbit <span className="logo-accent">Rush</span></span>
        </div>
        <div className={`conn-dot ${connected ? 'connected' : 'disconnected'}`}
             title={connected ? 'Connected' : 'Disconnected'} />
      </div>

      <div className="header-center">
        <div className={`mode-badge ${mode}`}>{mode.toUpperCase()}</div>
      </div>

      <div className="header-right">
        <div className="balance-display">
          <span className="balance-label">Balance</span>
          <span className="balance-value">{currency} {parseFloat(balance).toFixed(2)}</span>
        </div>
        <button
          className={`icon-btn ${soundEnabled ? 'active' : ''}`}
          onClick={() => setSoundEnabled(!soundEnabled)}
          title={soundEnabled ? 'Mute' : 'Unmute'}
        >
          {soundEnabled ? '🔊' : '🔇'}
        </button>
        <button
          className={`icon-btn ${animationsEnabled ? 'active' : ''}`}
          onClick={() => setAnimationsEnabled(!animationsEnabled)}
          title={animationsEnabled ? 'Disable animations' : 'Enable animations'}
        >
          {animationsEnabled ? '✨' : '⬜'}
        </button>
      </div>
    </header>
  );
}
